module.exports = __webpack_public_path__ + "images/existing-property-icon-0f620fc77a1b3754cf906c806abf55a8.svg";